/**
 
 * @internal
 * @ignore
 */
export const CryptoParams = {
    IvLength: 16,
    SharedKeyLength: 32
};
